import React from "react";
import {
  CardBody,
  Card,
} from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";
import { IChartTable } from "src/shared/models/IDashboards.models";
import { fCurrency } from '../../helpers/generalFunctions';

interface FormProps {
  details: IChartTable[];
  tabId: number;
  tableTitle: string;
  srcImage:string;
}


export const TransactionTitleValue = React.memo(({details, tableTitle, tabId, srcImage }: FormProps) => {
  return (
    <React.Fragment>
        <Card style={{border:"none"}}>
          <CardBody className="px-0 shadowCard" style={{paddingTop: "0px"}}>
            <SimpleBar
              className="table-responsive px-2"
              style={{ maxHeight: "190px" }}
            >
              <table className="table align-middle table-nowrap table-borderless">
                <thead>
                  <tr>
                    <th scope="col" >
                      <h5 className="font-size-11" style={{fontFamily: 'Open Sans,sans-serif',}}><strong>{tableTitle}</strong></h5>
                    </th>
                    <th scope="col" className="text-end" >
                      <img width="38px" style={{marginTop: "8px"}} height={"auto"} src={srcImage} alt="iconTable" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    details.map((item: any) => {
                      return <tr>
                          <td>
                            <div>
                              <h5 style={{color:"#505050"}} className="font-size-10 mb-1">{item.storeName}</h5>
                              <h5 style={{color:"#2196F3"}} className="font-size-10 mb-0">
                                {item.valueSymbol} {fCurrency(item.value1)}
                              </h5>
                            </div>
                          </td>

                          {
                            tabId == 2 ?
                              <td>
                                <div className="text-end">
                                  <h5 style={{color:"#505050"}} className="font-size-10 mb-0">
                                    {item.value2}
                                  </h5>
                                </div>
                              </td>
                            : tabId == 3 ?
                            <>
                            <td>
                              <div className="text-end">
                                <h5 style={{color:"#505050"}} className="font-size-10 mb-0">
                                  {item.valueSymbol} {fCurrency(item.value3)}
                                </h5>
                              </div>
                            </td>
                            <td>
                              <div className="text-end">
                                <h5 style={{color:"#505050"}} className="font-size-10 mb-0">
                                  {item.valueSymbol} {fCurrency(item.value4)}
                                </h5>
                              </div>
                            </td>
                            </>
                            : null
                          }
                      </tr>
                    })
                  }
                </tbody>
              </table>
            </SimpleBar>
          </CardBody>
        </Card>
    </React.Fragment>
  );
});
